import { render, staticRenderFns } from "./topbar.vue?vue&type=template&id=3547fbb1&scoped=true"
import script from "./topbar.vue?vue&type=script&lang=js"
export * from "./topbar.vue?vue&type=script&lang=js"
import style0 from "./topbar.vue?vue&type=style&index=0&id=3547fbb1&prod&lang=scss"
import style1 from "./topbar.vue?vue&type=style&index=1&id=3547fbb1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3547fbb1",
  null
  
)

export default component.exports